import { Component } from '@angular/core';
import { SelectTemplate } from 'src/app/@amiga-pyme/select/templates/select.template';
import {
  IUnitMeasure,
  UNIT_MEASURE_GROUP_TTL_ES
} from '../../unit-measure.interface';
import { UnitMeasureService } from '../../unit-measure.service';

@Component({
  selector: 'pg-unit-measure-select',
  template: `
    <ami-select
      [settings]="table.settings"
      [data]="table.data"
      (selectedRowsEvent)="onReciveSelectedRows($event)"
    ></ami-select>
  `
})
export class UnitMeasureSelectComponent extends SelectTemplate {
  constructor(private serviceBase: UnitMeasureService) {
    super(UNIT_MEASURE_GROUP_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.table.settings = {
      title: UNIT_MEASURE_GROUP_TTL_ES,
      columns: [
        { header: 'Nombre', field: 'description' },
        { header: 'Abreviatura', field: 'symbol' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IUnitMeasure[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
